import { Table as AccommodationContactsTable } from '@/components/accommodation_contact/table'

interface Props {
  id: string
}

export const EditContacts = ({ id }: Props) => {
  return (
    <>
      <AccommodationContactsTable
        accommodationId={id}
        pageSize={10}
        title="Contacts"
        createable
        fixedHeight
        updateable
      />
    </>
  )
}
